/* "On this page": links are rendered by the server. This file gives the matching headings an id, opens and closes the list on small screens and marks the current section. Article content is not changed. */
(function(){
function init(){
var prose=document.querySelector('[data-art-prose]'),toc=document.querySelector('[data-art-toc]');
if(!prose||!toc||toc.dataset.ready)return;
toc.dataset.ready='1';
var tag=toc.getAttribute('data-tag')||'h2',skipFirst=toc.hasAttribute('data-skip-first');
var links=[].slice.call(toc.querySelectorAll('ol a')),hs=[],n=0;
[].slice.call(prose.querySelectorAll(tag)).forEach(function(h){
n++;
if(skipFirst&&n===1)return;
if(h.closest('.author-info'))return;
if(!(h.textContent||'').trim())return;
hs.push(h);
});
if(hs.length!==links.length){toc.style.display='none';return}
hs.forEach(function(h,i){
var a=links[i],id=h.id||decodeURIComponent(a.getAttribute('href').slice(1))||('section-'+(i+1));
if(!h.id){var other=document.getElementById(id);if(other&&other!==h){id=id+'-'+(i+1)}h.id=id}
a.setAttribute('href','#'+id);
});
var btn=toc.querySelector('.art-toc-h');
btn.addEventListener('click',function(){var o=toc.classList.toggle('open');btn.setAttribute('aria-expanded',o?'true':'false')});
toc.querySelector('ol').addEventListener('click',function(e){if(e.target.tagName==='A'){toc.classList.remove('open');btn.setAttribute('aria-expanded','false')}});
var cur=-1,tick=false;
function mark(){
tick=false;var idx=0;
for(var i=0;i<hs.length;i++){if(hs[i].getBoundingClientRect().top<170)idx=i}
if(idx!==cur){if(cur>-1)links[cur].classList.remove('on');links[idx].classList.add('on');cur=idx}
}
window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(mark)}},{passive:true});
mark();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
